import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";

const { TextArea } = Input;

const NdrReattemptModal = ({
  showReattemptModal,
  setShowReattemptModal,
  selectedOrder,
  reattemptOrder, // mutation function
  reattempting, // loading state
}) => {
  const [form] = Form.useForm();

  // Helper to get tomorrow's date in YYYY-MM-DD format
  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  // Set form initial values when modal opens or selectedOrder changes
  useEffect(() => {
    if (selectedOrder) {
      const fullAddress = [
        selectedOrder?.BillingAddress?.AddressLine1,
        selectedOrder?.BillingAddress?.AddressLine2,
        selectedOrder?.BillingAddress?.City,
        selectedOrder?.BillingAddress?.State,
        selectedOrder?.BillingAddress?.Pincode,
      ]
        .filter(Boolean)
        .join(", ");

      form.setFieldsValue({
        address: fullAddress,
        phone: selectedOrder?.BillingAddress?.Contact || "",
        comments: "Reattempt order",
      });
    }
  }, [selectedOrder, form]);

  // Form submit handler
const handleSubmit = async (values) => {
  if (!selectedOrder) return;

  try {
    // Split address into two parts
    const address = values.address || "";
    const parts = address.split(",");
    const address1 = parts[0] || "";
    const address2 = parts.slice(1).join(",") || "";

    const payload = {
      awbNumber: selectedOrder?.awbNumber,
      action: "",           
      comments: values.comments,
      phone: values.phone,
      address1: address1,          
      address2: address2,          
      proof_image: "",
      proof_audio: "",
    };

    await reattemptOrder(payload);

    setShowReattemptModal(false);
  } catch (error) {}
};

  return (
    <Modal
      title="NDR Update Address"
      open={showReattemptModal}
      onCancel={() => setShowReattemptModal(false)}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="address"
          label="Address"
          rules={[{ required: true, message: "Please enter address" }]}
        >
          <TextArea rows={2} />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Contact Number"
          rules={[
            { required: true, message: "Please enter phone number" },
            {
              pattern: /^[0-9]{10}$/,
              message: "Please enter a valid 10-digit phone number",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="comments" label="Comments">
          <Input />
        </Form.Item>

        {/* Custom footer buttons */}
        <div className="flex justify-end space-x-2 mt-4">
          <button
            type="button"
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
            onClick={() => setShowReattemptModal(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={reattempting}
          >
            {reattempting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default NdrReattemptModal;
